
import React from 'react';
import { css } from 'aphrodite';

import styles from './styles.js';

const Rule = () => {
    return (
        <div style={{ marginTop: '16px', marginBottom: '16px' }}>
            <div className={css(styles.rule)} />
        </div>
    );
};

export default Rule;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/Rule/Rule.jsx